<template>
  <div
    :class="class_list"
    role="button"
    :aria-label="is_prev ? 'prev' : 'next'"
    class="swiper-slide-arrow_btn">
    <chevron-left-icon v-if="is_prev"/>
    <chevron-right-icon v-else/>
  </div>
</template>

<script>
import ChevronLeftIcon from "../icons/ChevronLeftIcon";
import ChevronRightIcon from "../icons/ChevronRightIcon";

export default {
  name: "SwiperSlideArrows",
  components: {ChevronRightIcon, ChevronLeftIcon},
  props: {
    is_prev: {
      type: Boolean,
      default: false,
    },
    hide_disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    class_list() {
      return {
        'swiper-button-prev': this.is_prev,
        'swiper-button-next': !this.is_prev,
        hide_disabled: this.hide_disabled
      }
    }
  }
}
</script>
